module.exports = __webpack_public_path__ + "img/icon-category.14a65607.svg";